import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getWidgetsSummaryMetrics = {
  name: "getWidgetsSummaryMetrics" as const,
  input: z.null(),
  output: z.object({
    // TODO(paul): use MoneySchema
    salesGeneratedByWidgets: z.object({
      shopCurrency: createEnum(Currency),
      value: z.number().optional(),
    }),
    checkoutConversionRateOverLast30Days: z.number().optional(),
    // TODO(paul): use MoneySchema
    revenueLiftPerOrder: z.object({
      shopCurrency: createEnum(Currency),
      value: z.number().optional(),
    }),
  }),
};
